module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2010-10-18.2c30bab0.md";